<template>
    <el-button type="text" plain  icon="el-icon-delete" v-on:click="clickEvent()">删除</el-button>
</template>
  
  <script>
  
  export default {
    name: 'table-delete-button',
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// TableDeleteButton.vue?9a3fad4c